import React, { Component } from 'react'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import Icon from "@material-ui/core/Icon";
import Popover from '@material-ui/core/Popover';

import _ from "lodash";

export default class DXFormInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    }
  }

  onClickInfo = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  }


  render() {
    const {
      pid,
      question,
      multiline = false,
      rows = 3,
      rowsMax = 3,
      valueState,
      onChange,
      classes
    } = this.props;
    const aNewId = `${pid}.${question.id}`;

    const { titleStyle = { sm: 2 }, tip = null } = question;
    const { sm } = titleStyle;
    const { anchorEl } = this.state;

    const error = _.get(valueState, `${aNewId}State`) === "error";

    return <GridContainer key={aNewId} justify='center'>
      <GridItem xs={12} sm={sm}>
        <div className={classes.question}>
          <h4 className={classes.infoText}>
            {
              question.required && error
                ? <span className={classes.required}>필수</span>
                : ''
            }
            {question.title}
            {
              tip
                ? <span className={classes.infoIconForQuestion}>
                  <Icon fontSize="small" color={"disabled"} onClick={this.onClickInfo}>info</Icon>
                  <Popover
                    id={aNewId}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div className={classes.tipArea}>{tip.split('\n').map(txt => <div>{txt}</div>)}</div>
                  </Popover>
                </span>

                : null
            }
          </h4>
        </div>
      </GridItem>
      <GridItem xs={12} sm={12 - sm}>
        <CustomInput
          success={_.get(valueState, `${aNewId}State`) === "success"}
          error={_.get(valueState, `${aNewId}State`) === "error"}
          labelText={
            <span>
              {question.title}
            </span>
          }
          id={aNewId}
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            onChange: event => onChange(event, aNewId, question.validation),
            multiline,
            rows,
            rowsMax,
            value: _.get(valueState, aNewId),
            readOnly: this.props.onChange === null,
            placeholder: question.placeholder,
          }}
        />
      </GridItem>
    </GridContainer>

  }
}
